<div class="row">
    <button class="btn btn-sigef mr-1" tabindex="{{tabindex}}" [disabled]="disable()" (click)="clickSave($event)">{{saveText()}}</button>
    <button class="btn btn-sigef-secondary mr-1" tabindex="{{tabindex + 1}}"  [disabled]="disable()" [hidden]="!allowCancel" (click)="clickCancel($event)">{{cancelButtonText}}</button>
    <button class="btn btn-outline-danger position-absolute" tabindex="{{tabindex + 2}}" style="right: 2rem" [disabled]="disable()" [hidden]="!allowDelete" (click)="clickDelete($event)"><i class="fas fa-exclamation-triangle"></i>&nbsp;{{deleteText()}}</button>
</div>

